module.exports = __webpack_public_path__ + "img/GAME_FINDSAMEPICTURE.3e8ca363.png";